import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import EditReviewModal from './edit_review_modal'; // Create this component
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
const ReviewsList = () => {
  const [reviews, setReviews] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchReviews();
  }, []);

  useEffect(() => {
    const filtered = reviews.filter((item) => {
      const text = searchText.toLowerCase();
      return (
        item.customer_name?.toLowerCase().includes(text) ||
        item.email?.toLowerCase().includes(text) ||
        item.review?.toLowerCase().includes(text) ||
        item.review_title?.toLowerCase().includes(text)
      );
    });
    setFilteredData(filtered);
  }, [searchText, reviews]);

  const fetchReviews = () => {
    setLoading(true);
    DataService.getReviews()
      .then((response) => {
        console.log(response.data.data)
        setReviews(response.data.data);
        setFilteredData(response.data.data);
      })
      .catch((error) => {
        console.error('Failed to fetch reviews:', error);
      })
      .finally(() => setLoading(false));
  };

  const handleEditClick = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this review?')) {
      setLoading(true);
      let data = {
        id:id
      }
      DataService.deleteReview(data)
        .then(() => {
            toast.success('Review Deleted successfully.')
            fetchReviews()
        }
        )
        .catch((err) => console.error('Delete failed:', err))
        .finally(() => setLoading(false));
    }
  };

  const toggleStatus = (review) => {
    const newStatus = review.status === 'approved' ? 'pending' : 'approved';
    const updated = {
      id: review.id,
      status: newStatus
    };
    setLoading(true);
    DataService.updateReviewStatus(updated)
      .then(() => {
        toast.success(`Review ${newStatus === 'approved' ? 'published' : 'unpublished'} successfully`);
        fetchReviews();
      })
      .catch((err) => {
        console.error('Status update failed:', err);
        toast.error('Failed to update review status');
      })
      .finally(() => setLoading(false));
  };

  const handleModalSave = (updatedReview) => {
    setLoading(true);
    DataService.editReview(updatedReview)
      .then(() => fetchReviews())
      .catch((err) => console.error('Update failed:', err))
      .finally(() => {
        setLoading(false);
        setShowModal(false);
      });
  };

  const renderStars = (rating) => {
    return (
      <div style={{ color: '#ffc107', fontSize: '14px' }}>
        {[1, 2, 3, 4, 5].map(star => (
          <span key={star}>{star <= rating ? '★' : '☆'}</span>
        ))}
      </div>
    );
  };

  const columns = [
    { name: 'Name', selector: row => row.customer_name, sortable: true, width: '150px' },
    { name: 'Email', selector: row => row.email, sortable: true, width: '180px' },
    {
      name: 'Rating',
      cell: row => renderStars(row.rating),
      sortable: true,
      width: '120px'
    },
    {
      name: 'Review Title',
      selector: row => row.review_title,
      sortable: true,
      width: '200px',
      wrap: true,
    },
    {
      name: 'Review',
      selector: row => row.review,
      grow: 2,
      wrap: true,
    },
    {
      name: 'Date',
      selector: row => row.created_at ? new Date(row.created_at).toLocaleDateString() : 'N/A',
      sortable: true,
      width: '110px'
    },
    {
      name: 'Status',
      cell: row => (
        <span
          className={`badge ${row.status === 'approved' ? 'bg-success' : row.status === 'rejected' ? 'bg-danger' : 'bg-warning text-dark'}`}
          style={{ cursor: 'pointer' }}
          onClick={() => toggleStatus(row)}
          title="Click to toggle publish/unpublish"
        >
          {row.status === 'approved' ? 'Published' : row.status === 'rejected' ? 'Rejected' : 'Pending'}
        </span>
      ),
      sortable: true,
      width: '110px'
    },
{
  name: 'Actions',
  cell: row => (
    <div className="d-flex gap-3 align-items-center">
      <FontAwesomeIcon
        icon={faEdit}
        className="text-primary"
        style={{ cursor: 'pointer', fontSize: '14px' }}
        onClick={() => handleEditClick(row)}
      />
      <FontAwesomeIcon
        icon={faTrash}
        className="text-danger"
        style={{ cursor: 'pointer', fontSize: '14px' }}
        onClick={() => handleDelete(row.id)}
      />
    </div>
  ),
}

  ];

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Customer Reviews</h4>
        </div>
        <input
          type="text"
          placeholder="Search by name, email, title or review content"
          className="form-control mb-3 px-3"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          striped
          responsive
          noHeader
        />
      </div>

      {showModal && (
        <EditReviewModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          review={selectedReview}
          onSave={handleModalSave}
        />
      )}
    </>
  );
};

export default ReviewsList;
